import React from 'react'
import '../../App.css'
import HeroSection from '../HeroSection'
import Skill from '../Skill'
import { motion } from 'framer-motion'
import ProjectData from '../ProjectData'
import Timeline from '../Timeline'
function Home() {
  return (
    <>
      <motion.div class="HomePage"
        intial={{ width: 0 }}
        animate={{ width: "100%" }}
        exit={{ x: window.innerWidth, transition: { duration: 0.5 } }}
      >
        <motion.div initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8, delay: 0.3 }}>
          <HeroSection />
        </motion.div>
        <motion.div initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8, delay: 0.3 }}>
          <Timeline />
        </motion.div>
        <motion.div initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8, delay: 0.3 }}>
          <Skill />
        </motion.div>
        <motion.div initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8, delay: 0.3 }}>
          <ProjectData />
        </motion.div>

      </motion.div>


    </>
  )
}

export default Home